export const state = {
    tokenLaravel: '',
    showMenu: false,
    user: {}
};